import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext, { event_name, properties }: { event_name: string; properties: unknown }) {
  this.sendEvent('analytics.dispatch', { event_name, properties })
}
